export class BarbourBlackbrookDirections {
    public static Init(): void {
        new BarbourBlackbrookDirections();
    }

    constructor() {
        document.querySelector(".view-direction")
            .addEventListener("click", (e) => this.onViewDirectionsClicked(e));
        document.getElementById("close-directions-box")
            .addEventListener("click", (e) => this.onCloseDirectionsClicked(e));
    }

    private onViewDirectionsClicked(e: Event): void {
        e.preventDefault();

        document.getElementById("mainContent").style.zIndex = "99999";
        document.querySelector(".blackbrook-direction").classList.remove("hidden");
        document.body.classList.add("cms-retailstore");
        // topmenu and popup-zindex appear unused.
        //document.querySelector(".topmenu").classList.add("popup-zindex");
    }

    private onCloseDirectionsClicked(e: Event): void {
        e.preventDefault();

        document.getElementById("mainContent").style.zIndex = "1";
        document.querySelector(".blackbrook-direction").classList.add("hidden");
        document.body.classList.remove("cms-retailstore");
        // topmenu and popup-zindex appear unused.
        //document.querySelector(".topmenu").classList.remove("popup-zindex");
    }
}

if (document.body.dataset.pageInit == "blackbrook-directions") {
    BarbourBlackbrookDirections.Init();
}
